module.exports = __webpack_public_path__ + "static/media/041.58b43a9f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/people/normals/041.jpg
// module id = 337
// module chunks = 0